module.exports = "https://cdn2-fs.clearscore.com/flux/images/cdb6f0dbe7a04be91b10e86b55ca66aa.jpg";